import { callFunction } from "./functions-client";

// Fleet management (LOS Phase 12) — a company/carrier's trucks and trailers.
export const VEHICLE_TYPES = ["truck", "trailer", "reefer_unit", "other"] as const;
export const VEHICLE_STATUSES = ["active", "maintenance", "out_of_service"] as const;
export type VehicleStatus = (typeof VEHICLE_STATUSES)[number];

export interface Vehicle {
  id: string;
  unit_number: string;
  type: string;
  status: VehicleStatus;
  equipment_type?: string | null;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  vin?: string | null;
  plate?: string | null;
  assigned_to?: string | null;
  notes?: string | null;
  updated_at?: string;
}

export interface NewVehicle {
  unit_number: string;
  type?: string;
  equipment_type?: string;
  make?: string;
  model?: string;
  year?: number;
  vin?: string;
  plate?: string;
  assigned_to?: string;
  notes?: string;
}

export const listVehicles = (status?: string) =>
  callFunction<{ vehicles: Vehicle[] }>(`fleet/list${status ? `?status=${encodeURIComponent(status)}` : ""}`, { method: "GET" });

export const getVehicle = (id: string) =>
  callFunction<{ vehicle: Vehicle }>(`fleet/get?id=${encodeURIComponent(id)}`, { method: "GET" });

export const createVehicle = (input: NewVehicle) =>
  callFunction<{ vehicle: Vehicle }>("fleet/create", { body: input });

export const updateVehicle = (input: { id: string } & Partial<NewVehicle>) =>
  callFunction<{ ok: boolean }>("fleet/update", { body: input });

export const setVehicleStatus = (id: string, status: VehicleStatus) =>
  callFunction<{ ok: boolean; status: VehicleStatus }>("fleet/set-status", { body: { id, status } });

export const assignVehicle = (id: string, assigned_to: string | null) =>
  callFunction<{ ok: boolean; assigned_to: string | null }>("fleet/assign", { body: { id, assigned_to } });
